export default __webpack_public_path__ + "static/custom-img-2-b65da6b94976fc6305bc797456eb924f.webp";